import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@lead-bridge/server';

export const trpc = createTRPCReact<AppRouter>();

/** A small wrapper so callers can `getQueryKey`-free invalidate everything after auth changes. */
export type { AppRouter };
